import styled from "@emotion/styled";

import Skeleton from "shared/components/Skeleton";

const StyledSkeleton = styled(Skeleton)`
  margin-bottom: 32px;
`;

export { StyledSkeleton };
